module.exports = __webpack_public_path__ + "static/media/Frontend_Firhan_Ramadhan_CV.4cd8dccc.pdf";